import React, { useState, useEffect } from 'react'
import { updateOrInsertStudentProgressCheck, getCheckedProgressCheckswithType } from '../../lib/studentprogresscheck'

const StudentProgressCheck = ({ studentId, type }) => {
	const [studentProgressChecks, setStudentProgressChecks] = useState([])

	// Fetch progress checks based on type
	const fetchProgressChecks = async () => {
		if (!type) {
			console.error('No progress check type provided')
			return
		}
		const checks = await getCheckedProgressCheckswithType(studentId, type)
		setStudentProgressChecks(checks)
	}

	const handleCheckboxChange = async (checkId, currentValue) => {
		await updateOrInsertStudentProgressCheck(studentId, checkId, !currentValue, type)
		fetchProgressChecks()
	}

	useEffect(() => {
		if (studentId && type) {
			fetchProgressChecks()
		}
	}, [studentId, type])

	return (
		<div className="card mt-4 shadow-sm">
			<div className="card-header bg-light border-bottom">
				<h6 className="mb-0 text-dark">Student Progress Checks</h6>
			</div>
			<div className="card-body p-3">
				<table className="table table-hover mb-0">
					<thead>
						<tr>
							<th>Description</th>
							<th>Score</th>
							<th>Checked</th>
						</tr>
					</thead>
					<tbody>
						{studentProgressChecks.length > 0 ? (
							studentProgressChecks.map((check) => (
								<tr key={check.progresscheckId}>
									<td>{check.description}</td>
									<td>{check.score}</td>
									<td>
										<input type="checkbox" checked={check.isCheck} onChange={() => handleCheckboxChange(check.progresscheckId, check.isCheck)} />
									</td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan="3" className="text-center">
									No progress checks available
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	)
}

export { StudentProgressCheck }
